import type { TOC } from '@ember/component/template-only';
import { formatNumber } from '../../utils/charts/chart-layout.ts';
import type { ChartDataPoint } from '../../types/charts.ts';

// ---------------------------------------------------------------------------
// SummaryDisplay – large value display (HTML-based, no canvas/SVG)
// Migrated from tio-common/utils/chart-renderer.ts renderSummary()
// ---------------------------------------------------------------------------

interface SummaryDisplaySignature {
  Args: {
    /** Chart data points — values are summed for display */
    data: ChartDataPoint[];
    /** Label below the value (default: "Total") */
    label?: string;
    /** Text color class (default: text-gray-900) */
    valueColor?: string;
  };
  Element: HTMLDivElement;
}

const getTotal = (data: ChartDataPoint[]) => data.reduce((sum, d) => sum + d.value, 0);

const getLabel = (label?: string) => label ?? 'Total';

const getValueColor = (color?: string) => color ?? 'tio-text-default';

const SummaryDisplay: TOC<SummaryDisplaySignature> = <template>
  <div
    data-test-chart
    data-test-chart-type="summary"
    class="flex flex-col items-center justify-center py-8"
    ...attributes
  >
    <span data-test-chart-value class="text-6xl font-bold {{getValueColor @valueColor}}">
      {{formatNumber (getTotal @data)}}
    </span>
    <span class="mt-2 text-sm tio-text-muted">
      {{getLabel @label}}
    </span>
  </div>
</template>;

export default SummaryDisplay;
export type { SummaryDisplaySignature };
